export default "__VITE_ASSET__Bw_D16SS__"